var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayStoreSvgrepoCom3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 30 32",
    enableBackground: "new 0 0 30 32",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#f9f5f5",
    d: "M27.881,12.934L5.908,0.477C5.36,0.165,4.584,0,3.942,0C1.851,0,0,1.589,0,3.542v24.916 C0,30.411,1.839,32,3.916,32c0.638,0,1.339-0.165,1.885-0.476l22.106-12.459c1.102-0.628,1.777-1.757,1.777-3.019 C29.685,14.748,29.022,13.585,27.881,12.934z M5.413,1.346l15.606,8.848l-4.785,5.076L2.994,1.226C3.347,1.083,3.721,1,4.091,1 C4.565,1,5.01,1.116,5.413,1.346z M1,28.458V3.542c0-0.728,0.484-1.337,0.978-1.779L15.473,16L1.937,30.241 C1.446,29.798,1,29.188,1,28.458z M5.381,30.654C4.979,30.884,4.536,31,4.064,31c-0.362,0-0.729-0.081-1.075-0.22l13.245-14.05 l4.798,5.089L5.381,30.654z M27.45,18.195l-5.521,3.117L16.922,16l4.994-5.297l5.47,3.101c0.825,0.47,1.317,1.308,1.317,2.242 C28.703,16.945,28.234,17.748,27.45,18.195z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStoreSvgrepoCom3);
export default __webpack_public_path__ + "static/media/play-store-svgrepo-com (3).59c5ec6892610d1030cfc6ea3ea89015.svg";
export { ForwardRef as ReactComponent };